export default __webpack_public_path__ + "static/media/reviwing docs gif.42fea359.gif";